document.addEventListener('DOMContentLoaded', function () {
  const addToCartButtons = document.querySelectorAll('.js-add-to-cart');

  addToCartButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const variantId = this.dataset.variantId;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        }),
      })
        .then((response) => response.json())
        .then(() => {
          window.location.href = '/cart';
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });
  });
});
